
import { defineComponent } from "vue";

export default defineComponent({
  name: "RatingStars",
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  methods: {
    buttonClickHandler(index: number) {
      this.$emit("update:modelValue", index);
    }
  }
});
